<div class="error-container">
  <h1>403 - Forbidden</h1>
  <p>You do not have permission to access this resource.</p>
  <p>Please contact your administrator if you believe this is an error.</p>
  <div class="tds-u-flex tds-u-gap3">
    <a routerLink="/{{dashboardPath}}">Go Back Home</a>
    <!-- <a routerLink="/{{requestAccessPath}}">Request Entitlements</a> -->
  </div>
</div>